/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Research_Art_HeadingInputs */

const en_services_svc_research_art_heading = /** @type {(inputs: Services_Svc_Research_Art_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`“How do Baltic vet clinics take bookings?”`)
};

const lv_services_svc_research_art_heading = /** @type {(inputs: Services_Svc_Research_Art_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`“Kā Baltijas veterinārās klīnikas pieņem pierakstus?”`)
};

/**
* | output |
* | --- |
* | "“How do Baltic vet clinics take bookings?”" |
*
* @param {Services_Svc_Research_Art_HeadingInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_research_art_heading = /** @type {((inputs?: Services_Svc_Research_Art_HeadingInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Research_Art_HeadingInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_research_art_heading(inputs)
	return en_services_svc_research_art_heading(inputs)
});